<template>
    <div id="app" class="page-wrapper">
        <div class="search-List" v-if="!isPhone" >
            <div class="search-input">
                <div class="search-icon">
                    <img src="../assets/img/search_icon.png" alt="">
                </div>
                <input type="text" placeholder="搜我求证谣言" maxlength="50" v-model="keyword" @keyup.enter="search">
                <div class="search-btn" @click="search">搜 索</div>
            </div>
            <div class="search-message" v-if="!showPlance">
                <div class="search-message-title">搜索结果</div>
                <div class="search-message-detail clearfix">
                    <span class="search-keyword">“{{keyword}}”相关的搜索结果</span>
                    <span class="search-number">共{{totalCount}}条搜索结果</span>
                </div>
            </div>
            <div v-show="keyword && noData" class="no-search-result">
                <p>无搜索结果，换个关键词试试吧~</p>
                <img src="./../assets/img/search_none.png" alt="">
            </div>
            <div v-show="showPlance" class="search-plance">
                <img src="../assets/img/search_plance.png" alt="">
            </div>
            <NewsList :list="list"/>
            <div v-show="!noData && (isLoading || (list.length && list.length == totalCount))" class="loadMore">
                {{(list.length && list.length == totalCount) ? '已经到底了' : '加载更多...'}}
            </div>
        </div>
        <div class="search-List" v-if="isPhone" >
            <div class="search-input">
                <div class="search-icon">
                    <img src="../assets/img/search_icon.png" alt="">
                </div>
                <input type="text" placeholder="搜我求证谣言" maxlength="50" v-model="keyword" @keyup.enter="search">
                <div class="search-btn" @click="search">搜 索</div>
            </div>
            <div class="search-message" v-if="!showPlance">
                <div class="search-message-title">搜索结果共{{totalCount}}条</div>
            </div>
            <div v-if="keyword && noData" class="no-search-result">
                <p>无搜索结果，换个关键词试试吧~</p>
                <img src="./../assets/img/search_none.png" alt="">
            </div>
            <div v-if="showPlance" class="search-plance">
                请在输入框中输入您要查证的谣言~
            </div>
            <NewsList :list="list"/>
            <div v-show="!noData && (isLoading || (list.length && list.length == totalCount))" class="loadMore">
                {{(list.length && list.length == totalCount) ? '已经到底了' : '加载更多...'}}
            </div>
        </div>
        <GoHome v-if="isPhone" />
    </div>
</template>
<script>
import NewsList from '@/components/NewsList'
import { mapState, mapMutations } from 'vuex'
import GoHome from '@/components/GoHome.vue';
export default {
    name: 'Search',
    data() {
        return {
            list: [],
            isLoading: false,
            keyword: '',
            page: 1,
            pageSize: 50,
            noData: false,
            showPlance: true,
            totalCount: 0
        }
    },
    components: {
        NewsList,
        GoHome
    },
    created() {
        // 获取列表数据
        document.title = "四川互联网举报辟谣平台";
        this.keyword = this.$route.query.keyword || '';
        this.setInit();
        if (this.keyword.trim() !== '') {
            this.getData();
        }
    },
    mounted() {
        this.isPhone && this.$Common.onShare({
            shareTitle: '四川互联网举报辟谣平台',
            shareUrl: window.location.href,
            shareBrief: '四川互联网举报辟谣平台',
            shareImg: 'https://wapcdn.thecover.cn/cdn/cover_pc/static/img/2x/piyao_share_logo.png?version=v1',
        })
    },
    methods: {
        ...mapMutations(['freshSearch', 'setLoadingShow']),
        getData(flag) {
            if (this.keyword.trim() === '') {
                this.setInit();
                return;
            }
            if(this.noData || this.isLoading || (this.list.length && this.list.length >= this.totalCount)) {
                return;
            }
            this.isLoading = true
            this.$axios.post(
                this.$ApiInfo.getSearchResult,
                {
                    page: this.page,
                    pageSize: this.pageSize,
                    keyword: this.keyword,
                    queryAllImg: true
                }
            ).then(data => {
                if(this.page == 1 && !this.noData) {
                    if(!data || !data.list || !data.list.length) {
                        this.noData = true;
                        this.showPlance = false;
                        this.setLoading();
                        this.freshSearch(false);
                        return;
                    }
                }
                this.showPlance = false;
                if(data && data.list && data.list.length) {
                    this.list.push(...data.list);
                }
                this.totalCount = data.totalCount;
                this.page++;
                this.isLoading = false;
                this.setLoading();
                this.freshSearch(false);
            })
        },
        setInit() {
            this.setLoadingShow(false)
            this.list = [];
            this.isLoading = false;
            this.page = 1;
            this.pageSize = 50;
            this.noData = false;
            this.showPlance = true;
            this.totalCount = 0;
        },
        setLoading() {
            this.setLoadingShow(false);
            this.$nextTick(()=> {
                let footerHeight = 0;
                document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 50)
                this.$Common.loadScroll(footerHeight, this.getData);
            })
        },
        search() {
            this.setInit();
            this.getData();
        }
    },
    watch: {
        freshSearchFlag(val) {
            if(val) {
                this.setInit();
                this.keyword = this.$route.query.keyword || '';
                this.getData();
            }
        },
        keyword(val) {
            if(typeof val == 'string' && val.trim() === '') {
                this.setInit();
            }
        }
    },
    computed: {
        ...mapState(['freshSearchFlag']),
        isPhone() {
            return this.$Common.Attribute.isMb()
        },
    }
}
</script>
<style lang="less" scoped>
.no-search-result {
    color: #fff;
    font-size: 1.5rem;
    text-align: center;
    margin-top: 1.875rem;
    margin-bottom: 5.625rem;
    img {
        width: 4.75rem;
        height: 5rem;
        margin-top: 2.75rem;
    }
}

.pc-wrapper {
    .search-input {
        position: relative;
        margin-top: 1.1111rem;
        margin-bottom: 1.6667rem;
        width: 57rem;
        height: 2.8889rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        .search-icon {
            position: absolute;
            left: 1rem;
            top: .9rem;
            width: 1rem;
            height: 1rem;
            img {
                width: 100%;
                height: 100%;
            }
        }
        input {
            position: absolute;
            left: 2.49rem;
            width: 44rem;
            height: 100%;
            text-indent: .6875rem;
            color: #626262;
            border: none;
            outline: 0;
            font-size: 1rem;
        }
        .search-btn {
            position: absolute;
            right: .5rem;
            top: .2222rem;
            width: 9.1111rem;
            height: 2.4444rem;
            border-radius: .2222rem;
            line-height: 2.4444rem;
            text-align: center;
            color: #fff;
            background: linear-gradient( #182476 0%, #002FA7 100%);
            cursor: pointer;
        }
    }
    .search-plance  {
        margin-top: 6.6667rem;
        margin-bottom: 5.625rem;
        display: flex;
        justify-content: center;
        img {
            display: block;
            width: 23.6667rem;
            height: 4rem;
        }
    }
    .search-message {
    margin-top: 0.625rem;
    margin-bottom: 1.5rem;
    color: #fff;
    .search-message-title {
        font-size: 1.125rem;
        line-height: 1.5625rem;
        border-bottom: 0.125rem solid #fff;
        padding-bottom: 0.25rem;
    }
    .search-message-detail {
        font-size: 1.375rem;
        line-height: 1.875rem;
        margin-top: 1rem;
        .search-keyword {
            font-size: 1.375rem;
            float: left;
        }
        .search-number {
            font-size: 1.125rem;
            float: right;
        }
    }
}
}
.wap-wrapper {
    .search-input {
        position: relative;
        margin: .9375rem .9375rem;
        width: 21.5625rem;
        height: 2.8889rem;
        border-radius: 4px;
        border: 2px solid rgba(0,0,0,0.15);
        box-sizing: border-box;
        .search-icon {
            position: absolute;
            left: .625rem;
            top: .8rem;
            width: 1.125rem;
            height: 1.125rem;
            img {
                width: 100%;
                height: 100%;
            }
        }
        input {
            position: absolute;
            left: 2rem;
            width: 14rem;
            height: 100%;
            text-indent: .375rem;
            color: #BFBFBF;
            border: none;
            outline: 0;
            font-size: 1rem;
        }
        .search-btn {
            position: absolute;
            right: 0;
            top: 0;
            width: 5rem;
            height: 100%;
            background: #0076FF;
            border-radius: 0px 4px 4px 0px;
            line-height: 2.4444rem;
            text-align: center;
            color: #fff;
        }
    }
    .search-plance  {
        margin-top: 6.6667rem;
        margin-bottom: 5.625rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999;
        font-size: 1rem;
    }
    .no-search-result {
        color: #999;
        font-size: 1rem;
    }
    .search-message {
        color: #333;
        padding-left: .9375rem;
        font-size: 1rem;
    }
}
</style>